"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = exports.debounce = void 0;
const nowFn = () => {
    return new Date().getTime();
};
const debounce = function _debounce(func_, wait_, immediate_) {
    let timeout;
    let later;
    let context;
    let callNow;
    let args;
    return () => {
        context = this;
        args = arguments;
        later = () => {
            timeout = null;
            if (!immediate_) {
                func_.apply(context, args);
            }
        };
        callNow = immediate_ && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait_);
        if (callNow) {
            func_.apply(context, args);
        }
    };
};
exports.debounce = debounce;
const throttle = function _throttle(func_, wait_) {
    let context, now, remaining, args, result, timeout = null, previous = 0;
    const later = () => {
        previous = nowFn();
        timeout = null;
        result = func_.apply(context, args);
        args = null;
        context = null;
    };
    return () => {
        now = nowFn();
        remaining = wait_ - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func_.apply(context, args);
            args = null;
            context = null;
        }
        else if (!timeout) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};
exports.throttle = throttle;
//# sourceMappingURL=dom.js.map